import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Ratingstar = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M11.315 2.18a.76.76 0 0 1 1.37 0l2.368 4.93a.76.76 0 0 0 .586.423l5.45.713a.755.755 0 0 1 .423 1.299L17.528 13.3a.75.75 0 0 0-.225.687l1 5.366a.758.758 0 0 1-1.107.803l-4.835-2.606a.76.76 0 0 0-.722 0l-4.835 2.606a.758.758 0 0 1-1.108-.803l1-5.366a.75.75 0 0 0-.224-.687L2.488 9.545a.755.755 0 0 1 .423-1.299l5.45-.713a.76.76 0 0 0 .586-.423z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.36 1.855c-.547-1.14-2.174-1.14-2.722 0L8.27 6.785q0 .002-.007.004l-5.45.714c-1.256.164-1.768 1.713-.84 2.587l3.984 3.757q.003.002.002.003l-1 5.367c-.234 1.252 1.09 2.198 2.2 1.6l4.835-2.606a.01.01 0 0 1 .01 0l4.836 2.606c1.109.598 2.434-.348 2.2-1.6l-1-5.367.002-.003 3.984-3.757c.927-.874.415-2.423-.84-2.587l-5.45-.714q-.007-.002-.007-.004z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
